export const SCHEDULED_NOTIFICATION_WINDOW = {
  BEFORE_DELIVERY: 10 * 60000,
  WINDOW_30M: 30 * 60000,
  WINDOW_1H: 60 * 60000,
  WINDOW_1H30M: 90 * 60000,
}
